import { useMutation } from '@tanstack/react-query';

import { useHttpClient, type HttpResponse } from '@bonusly/http-client';

import { Bonus } from '../../../../../../types/bonus';
import { ResourcePath } from '../../../hooks/resource-path';
import { MutationOptions } from '../../../hooks/types';
import { RecognizeResponse } from '../../../types/api';
import { pathWithId } from '../../../utils/api';

export interface BonusDeleteArgs {
	id: string;
}

export const useDeleteBonus = (options: MutationOptions<BonusDeleteArgs, HttpResponse<RecognizeResponse<Bonus>>> = {}) => {
	const httpV1 = useHttpClient('v1');
	return useMutation(
		({ id }: BonusDeleteArgs) => httpV1.delete<RecognizeResponse<Bonus>, HttpResponse<RecognizeResponse<Bonus>>>(pathWithId(ResourcePath.Bonus, id), {}),
		options
	);
};
